import { useEffect, useState } from "react";

const useExpirationStatus = (apiUrl, token) => {
	const [expirationStatus, setExpirationStatus] = useState(null);

	const checkLinkExpiration = async (apiUrl, token) => {
	    try {
	        const response = await fetch(`${apiUrl}/api/check_link_expiration?token=${token}`, {
	            method: "GET",
	            headers: {"Content-Type": "application/json"}
	        });
	        const data = await response.json();
	        return data.expired;
	    } catch (err) { console.log("error fetching expiration status: ", err); }
	};  

	useEffect(() => {
		const checkExpiration = async () => {
			const result = await checkLinkExpiration(apiUrl, token);
			setExpirationStatus(result);
		};
		if (token) checkExpiration();
	}, [apiUrl, token]);

	return expirationStatus;
};

export default useExpirationStatus;
